<template>
  <div class="video-upload-container">
    <el-row :gutter="24">
      <!-- 左侧上传区域 -->
      <el-col :xs="24" :sm="24" :md="14" :lg="13">
        <div class="upload-section">
          <div class="section-header">
            <i class="el-icon-upload"></i>
            <span>文件上传</span>
          </div>

          <!-- 缩略图描述 -->
          <div class="form-item">
            <span class="form-label">缩略图描述：</span>
            <el-input
              v-model="title"
              size="small"
              placeholder="请输入缩略图描述文字"
              maxlength="50"
              show-word-limit
              style="width: 300px">
            </el-input>
          </div>

          <!-- 上传区域 -->
          <div class="upload-area">
            <el-upload
              class="upload-drag"
              drag
              action=""
              :file-list="fileList"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :auto-upload="false"
              accept=".jpg,.png,.mp4">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                <i class="el-icon-info"></i> 支持 jpg/png/mp4 格式，文件不超过 50MB
              </div>
            </el-upload>
          </div>

          <!-- 操作按钮 -->
          <div class="action-buttons">
            <el-button
              type="success"
              size="small"
              icon="el-icon-view"
              @click="preview"
              :disabled="!currentFile">
              预览缩略图
            </el-button>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-upload"
              @click="uploadFile"
              :loading="loading">
              开始上传
            </el-button>
          </div>

          <!-- 隐藏元素 -->
          <video
            :src="blobVideoUrl"
            id="upvideo"
            preload="meta"
            loop
            muted
            controls
            v-show="false">
          </video>
          <canvas id="mycanvas" style="display: none"></canvas>
          <el-image
            id="imgs"
            style="width:234px;height: 150px;display: none;"
            @load="findimgcover"
            :src="blobImgUrl">
          </el-image>
        </div>
      </el-col>

      <!-- 右侧预览区域 -->
      <el-col :xs="24" :sm="24" :md="10" :lg="11">
        <div class="preview-section" v-if="productViewShow">
          <div class="section-header">
            <i class="el-icon-picture-outline"></i>
            <span>资源预览</span>
            <el-tag size="mini" type="info">{{ productList.length }} 个资源</el-tag>
          </div>

          <div class="preview-grid" :style="{height: height + 'px'}">
            <el-card
              v-for="(item, i) in productList"
              :key="i"
              class="preview-card"
              shadow="hover">
              <el-image
                class="preview-media"
                :id="item.productCode"
                v-if="item.sourceType == 3"
                :title="item.productCode + '.jpg'"
                :src="item.sourceUrl"
                :preview-src-list="[item.sourceUrl]">
                <div slot="error" class="media-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <video
                :id="item.productCode"
                v-else
                :title="item.productCode + '.mp4'"
                preload="meta"
                controls
                :src="item.sourceUrl">
              </video>
              <div class="media-info">
                <span class="media-code">{{ item.productCode }}</span>
              </div>
            </el-card>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 缩略图预览对话框 -->
    <el-dialog
      title="缩略图预览"
      :visible.sync="dialogFormVisible"
      width="500px"
      class="bg-dialog preview-dialog"
      center>
      <div class="preview-content">
        <el-image
          v-show="!isVideo && imgForImage"
          :src="imgForImage"
          fit="contain"
          class="preview-thumbnail">
        </el-image>
        <el-image
          v-show="isVideo && imgForVideo"
          :src="imgForVideo"
          fit="contain"
          class="preview-thumbnail">
        </el-image>
        <div v-if="!imgForImage && !imgForVideo" class="no-preview">
          <i class="el-icon-picture-outline"></i>
          <p>暂无预览</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">关闭</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Enumerable from 'linq'
import api from '@/utils/api'

export default {
  name: 'Video',
  data () {
    return {
      productViewShow: true,
      dialogFormVisible: false,
      key: '',
      blobVideoUrl: '',
      blobImgUrl: '',
      isVideo: false,
      imgForImage: '',
      imgForVideo: '',
      selectTab: 'PC',
      tabPosition: 'left',
      tableHeight: '',
      loading: false,
      fileList: [],
      title: '',
      thurmbnail: { key: '', content: '' },
      currentFile: '',
      canvasHeight: 135,
      canvasWidth: 235,
      sourceType: ''
    }
  },
  mounted () {
    this.tableHeight = (window.innerHeight - 285) + 'px'
  },
  methods: {
    async uploadFile () {
      if (this.loading) {
        return false
      }
      if (this.thurmbnail.content === '') {
        this.$message({ message: '请先上传文件', type: 'warning' })
        return
      }
      var file = this.currentFile
      var formData = new FormData()
      formData.append('productCode', this.productCode)
      formData.append('file', file.raw)
      formData.append('thurmbnail', this.thurmbnail.content)
      formData.append('filename', file.name)
      formData.append('action', this.selectCheckbox)
      this.loading = true
      var _this = this
      return this.$axios.post(api.upload, formData, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 5 * 60 * 1000 })
        .then(res => {
          if (res.data.result === 'SUCCESS') {
            if (_this.selectCheckbox.indexOf('2') !== -1) {
              _this.dialogFormVisible = true
            }
            _this.loading = false
            _this.productViewShow = false
            _this.$nextTick(() => {
              _this.productViewShow = true
            })
            _this.$message({ message: file.name + '文件上传成功', type: 'success' })
            _this.fileList = []
            _this.currentFile = ''
            _this.thurmbnail = { key: '', content: '' }
            return true
          } else {
            _this.loading = false
            _this.$message({ message: res.data.result, type: 'error' })
            return false
          }
        })
        .catch(function (error) {
          var message = error.code === 'ECONNABORTED'
            ? '上传超时，请检查文件大小或服务器上传限制'
            : ((error.response && error.response.data && (error.response.data.result || error.response.data.msg)) || error.message || '上传失败')
          _this.$message({ message: message, type: 'error' })
          _this.loading = false
          return false
        })
    },
    preview () {
      if (this.currentFile === '') {
        this.$message({ message: '请先上传文件', type: 'warning' })
        return
      }
      if (this.isVideo) {
        const URL = window.URL || window.webkitURL
        this.blobVideoUrl = URL.createObjectURL(this.currentFile.raw)
        this.findvideocover(this.blobVideoUrl, this.currentFile.name)
        this.dialogFormVisible = true
      } else {
        this.findimgcover()
        this.dialogFormVisible = true
      }
    },
    handleChange (file, fileList) {
      this.currentFile = file
      this.fileList = fileList
      this.videolist = fileList.length
      const URL = window.URL || window.webkitURL
      this.isVideo = file.name.indexOf('mp4') > 0
      this.sourceType = file.name.substr(file.name.length - 5, 1)
      if (this.isVideo) {
        this.blobVideoUrl = URL.createObjectURL(file.raw)
        this.findvideocover(this.blobVideoUrl, file.name)
      } else {
        this.blobImgUrl = URL.createObjectURL(file.raw)
        this.thurmbnail.key = file.name
      }
      var prod = Enumerable.from(this.productList).firstOrDefault(f => f.sourceUrl.indexOf(file.name) > 0)
      if (prod) {
        this.title = prod.thumbnailDescription
      }
    },
    handleRemove () {
      this.currentFile = ''
      this.thurmbnail = { key: '', content: '' }
    },
    beforeUpload (file) {
      if (this.productCode === undefined) {
        this.$message({ message: '请先上传文件', type: 'warning' })
        return false
      }
      var arr = this.productCode.split('-')
      if (arr.length !== 4) {
        this.$message({ message: '请先选择需要上传的单元', type: 'warning' })
        return false
      }
      if (file.size > 110 * 1024 * 1024) {
        this.$message({ message: '文件不允许大于110M', type: 'warning' })
        return false
      }
      if (!(file.name.indexOf('png') > 0) && !(file.name.indexOf('jpg') > 0) && !(file.name.indexOf('mp4') > 0)) {
        this.$message({ message: '只允许mp4/jpg/png格式文件', type: 'warning' })
        return false
      }
      return true
    },
    findvideocover (url, fileName) {
      const video = document.getElementById('upvideo')
      video.src = url
      var canvas = document.getElementById('mycanvas')
      const ctx = canvas.getContext('2d')
      video.crossOrigin = 'anonymous'
      video.currentTime = 1
      video.oncanplay = () => {
        canvas.width = this.canvasWidth
        canvas.height = this.canvasHeight
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
        if (this.sourceType === '2') {
          ctx.font = '28px 宋体 bolder'
          ctx.fillStyle = '#000000'
          ctx.fillText(this.title, (canvas.width - ctx.measureText(this.title).width) / 2, canvas.height - 20)
        }
        this.imgForVideo = canvas.toDataURL('image/png')
        this.thurmbnail.content = canvas.toDataURL('image/png')
        this.thurmbnail.key = fileName
      }
    },
    findimgcover () {
      const img = document.getElementById('imgs')
      var canvas = document.getElementById('mycanvas')
      const ctx = canvas.getContext('2d')
      img.src = this.blobImgUrl
      canvas.width = this.canvasWidth
      canvas.height = this.canvasHeight
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      ctx.font = '28px 宋体 bolder'
      ctx.fillStyle = '#000000'
      ctx.fillText(this.title, (canvas.width - ctx.measureText(this.title).width) / 2, canvas.height - 25)
      this.imgForImage = canvas.toDataURL('image/png')
      this.thurmbnail.content = canvas.toDataURL('image/png')
    }
  },
  props: {
    productList: {
      type: Array,
      default: () => ([])
    },
    productCode: {
      type: String
    },
    selectCheckbox: {
      type: Array
    },
    height: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.video-upload-container {
  padding: $spacing-lg;
  background: var(--bg-base);
  min-height: calc(100vh - 120px);
}

.upload-section,
.preview-section {
  background: var(--bg-white);
  border-radius: $border-radius-base;
  padding: $spacing-lg;
  box-shadow: var(--shadow-base);
  height: 100%;
}

.section-header {
  display: flex;
  align-items: center;
  gap: $spacing-sm;
  margin-bottom: $spacing-lg;
  padding-bottom: $spacing-md;
  border-bottom: 1px solid $border-lighter;
  font-size: $font-size-lg;
  font-weight: 600;
  color: var(--text-primary);

  i {
    color: $primary-color;
    font-size: $font-size-xl;
  }

  .el-tag {
    margin-left: auto;
  }
}

.form-item {
  display: flex;
  align-items: center;
  gap: $spacing-md;
  margin-bottom: $spacing-lg;

  .form-label {
    font-weight: 600;
    color: var(--text-primary);
    white-space: nowrap;
  }
}

.upload-area {
  margin-bottom: $spacing-lg;

  .upload-drag {
    ::v-deep .el-upload {
      width: 100%;
    }

    ::v-deep .el-upload-dragger {
      width: 100%;
      height: 200px;
      border: 2px dashed $border-base;
      border-radius: $border-radius-base;
      transition: $transition-base;

      &:hover {
        border-color: $primary-color;
        background: $primary-lighter;
      }

      .el-icon-upload {
        font-size: 48px;
        color: $primary-color;
        margin-top: 40px;
      }

      .el-upload__text {
        margin-top: $spacing-md;
        color: var(--text-regular);

        em {
          color: $primary-color;
          font-weight: 600;
        }
      }

      .el-upload__tip {
        margin-top: $spacing-md;
        color: $text-secondary;

        i {
          color: $warning-color;
          margin-right: 4px;
        }
      }
    }
  }
}

.action-buttons {
  display: flex;
  gap: $spacing-md;
  justify-content: flex-start;
}

.preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: $spacing-md;
  overflow-y: auto;
  padding-right: $spacing-sm;

  @include scrollbar;

  .preview-card {
    border-radius: $border-radius-sm;
    overflow: hidden;

    ::v-deep .el-card__body {
      padding: $spacing-sm;
    }

    .preview-media {
      width: 100%;
      height: 100px;
      object-fit: cover;
      border-radius: $border-radius-sm;
      cursor: pointer;
      transition: $transition-base;

      &:hover {
        transform: scale(1.02);
      }
    }

    video {
      width: 100%;
      height: 100px;
      border-radius: $border-radius-sm;
      object-fit: cover;
    }

    .media-error {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: $bg-base;
      border-radius: $border-radius-sm;
      color: $text-placeholder;
      font-size: 24px;
    }

    .media-info {
      margin-top: $spacing-sm;
      text-align: center;

      .media-code {
        font-size: $font-size-xs;
        color: $text-secondary;
        word-break: break-all;
      }
    }
  }
}

// 预览对话框
.preview-dialog {
  .preview-content {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    background: $bg-base;
    border-radius: $border-radius-base;
    padding: $spacing-lg;

    .preview-thumbnail {
      max-width: 100%;
      max-height: 350px;
      border-radius: $border-radius-sm;
      box-shadow: var(--shadow-base);
    }

    .no-preview {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: $text-placeholder;

      i {
        font-size: 48px;
        margin-bottom: $spacing-md;
      }

      p {
        font-size: $font-size-md;
      }
    }
  }
}

// 响应式适配
@media (max-width: $screen-md) {
  .video-upload-container {
    padding: $spacing-md;
  }

  .upload-section,
  .preview-section {
    margin-bottom: $spacing-lg;
  }

  .preview-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
}

@media (max-width: $screen-sm) {
  .form-item {
    flex-direction: column;
    align-items: flex-start;

    .el-input {
      width: 100% !important;
    }
  }

  .action-buttons {
    flex-direction: column;

    .el-button {
      width: 100%;
    }
  }

  .preview-grid {
    grid-template-columns: repeat(2, 1fr);
    height: auto !important;
    max-height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bg/Video.vue